const ProgressBar = require("progressbar.js");
const $ = require("jquery");
const QRCode = require("qrcode");

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

// Reset FAQ search input when reset button is clicked
$(function () {
  var searchInput = document.querySelector('[data-drupal-selector="edit-search-api-fulltext"]');
  var resetButton = document.querySelector('[data-drupal-selector="edit-reset-faq-search"]');

  if (!searchInput || !resetButton) return; // Ensure elements exist

  // Reset search field
  resetButton.addEventListener('click', function (e) {
    searchInput.value = ''; // Clear input field
  });

  // Close keyboard when tapping outside the search input
  document.addEventListener('touchstart', function (e) {
    if (!searchInput.contains(e.target) && document.activeElement === searchInput) {
      hideSoftKeyboard();
    }
  });

  // Close keyboard when clicking outside (for desktop)
  document.addEventListener('click', function (e) {
    if (!searchInput.contains(e.target) && document.activeElement === searchInput) {
      hideSoftKeyboard();
    }
  });

  // Utility function to close the keyboard
  function hideSoftKeyboard() {
    if (document.activeElement && typeof document.activeElement.blur === 'function') {
      document.activeElement.blur(); // Works in most browsers
    }

    // Some newer browsers support a better way:
    if ('hideSoftKeyboard' in window.navigator) {
      window.navigator.hideSoftKeyboard();
    }
  }
});



// Rapid response collapse
$(function () {
  $(".rapid-response").on('click', '.field--name-body, h2', function () {
    $(".rapid-response-section").toggleClass("expanded");
  });
});

if (document.getElementById("social-media-actions") != null) {
  var socialMediaBar = new ProgressBar.Circle("#social-media-actions .bar", {
    color: "#FFFFFF",
    // This has to be the same size as the maximum width to
    // prevent clipping
    strokeWidth: 4,
    trailWidth: 1,
    easing: "easeInOut",
    duration: 1400,
    text: {
      autoStyleContainer: false,
    },
    from: { color: "#EBEBEB", width: 4 },
    to: { color: "#FFFFFF", width: 4 },
    // Set default step function for all animate calls
    step: function (state, circle) {
      circle.path.setAttribute("stroke", state.color);
      circle.path.setAttribute("stroke-width", state.width);

      var value = Math.round(circle.value() * 100);
      if (value === 0) {
        circle.setText("0 %");
      } else {
        circle.setText(value + " %");
      }
    },
  });

  socialMediaBar.text.style.fontFamily =
    '"Soleil Semibold", Helvetica, sans-serif';
  socialMediaBar.text.style.fontSize = "42px";
  socialMediaBar.animate(parseInt($(".percentage-circle .value").html()) / 100); // Number from 0.0 to 1.0
}

if (document.getElementById("people-actions") != null) {
  var socialMediaBar = new ProgressBar.Circle("#people-actions .bar", {
    color: "#333333",
    // This has to be the same size as the maximum width to
    // prevent clipping
    strokeWidth: 5,
    trailWidth: 5,
    easing: "easeInOut",
    duration: 1400,
    text: {
      autoStyleContainer: false,
    },
    from: { color: "#FFB43D", width: 5 },
    to: { color: "#FED667", width: 5 },
    // Set default step function for all animate calls
    step: function (state, circle) {
      circle.path.setAttribute("stroke", state.color);
      circle.path.setAttribute("stroke-width", state.width);
      circle.path.setAttribute("stroke-linecap", "round");

      var value = Math.round(circle.value() * 100);
      if (value === 0) {
        circle.setText("0 <span>%</span>");
      } else {
        circle.setText(value + " <span>%</span>");
      }
    },
  });

  socialMediaBar.text.style.fontFamily =
    '"Soleil Semibold", Helvetica, sans-serif';
  socialMediaBar.text.style.fontSize = "32px";
  socialMediaBar.animate(parseInt($(".percentage-circle .value").html()) / 100); // Number from 0.0 to 1.0
}

/**
 * Menu
 */
$(function () {
  function toggleDivs() {
    var $inner = $(".uv-header");
    if ($inner.css("margin-left") == "-290px") {
      $inner.animate({ "margin-left": "0" });
      $(".menu-overlay").show();
    } else {
      $inner.animate({ "margin-left": "-290px" });
      $(".menu-overlay").hide();
    }
  }
  $("#nav-hamburger").bind("click", function () {
    toggleDivs();
  });

  $("#nav-close").bind("click", function () {
    toggleDivs();
  });

  $(".menu-overlay").bind("click", function () {
    toggleDivs();
  });
});

/**
 * Range Slider Value
 */
$(function () {

  $(".path-profile input[type=range]").each(function () {
    let rangeSlider = $(this);
    let sliderValue = rangeSlider.val();
    let sliderPerCentValue = sliderValue / 3;

    let sliderTotal = rangeSlider.parent('.form-item').siblings('.slider-total-wrapper').find('.slider-total');

    let sliderTotalVal = '0';

    if (sliderTotal.length) {
      sliderTotalVal = sliderTotal.html();
      sliderTotal.html(parseInt(sliderTotalVal) + parseInt(sliderValue));
    }

    if (sliderValue > 5) {
      sliderPerCentValue = (sliderValue - 5) / 3;
    }
    rangeSlider.after(
      `<span class="range-value" style="left:${sliderPerCentValue}%"><em class="range-numeric-value">${sliderValue}</em> €</span>`
    );
    rangeSlider.on("input", function () {
      sliderValue = rangeSlider.val();

      let rangeValue = rangeSlider.siblings('.range-value');
      let rangeNumericValue = rangeValue.find('.range-numeric-value');

      if (sliderValue <= 5) {
        rangeNumericValue.html(sliderValue);
        rangeValue.css({ left: "0" });
      } else {
        sliderPerCentValue = (sliderValue - 10) / 3;
        rangeNumericValue.html(sliderValue);
        rangeValue.css({ left: sliderPerCentValue + "%" });
      }

      if (sliderTotal.length) {
        setTimeout(() => {
          sliderTotal.html(
            parseInt(sliderTotalVal) + parseInt(sliderValue)
          );
        }, 1000);
      }
    });
  });



  if (document.getElementById("membership-fee-edit-form") != null) {

  }
});

$(function () {
  $("form.profile-edit-form").submit(function (e) {
    e.preventDefault();
  });
  $("form input").on("invalid", function (event) {
    $(this).addClass("error");
  });
});


$(function () {
  $('.info-panel .expand-button').on('click', function () {
    let infoPanel = $(this).parent(".info-panel");
    if (infoPanel.hasClass('show')) {
      infoPanel.removeClass('show');
      infoPanel.find('p').removeClass('show');
    } else {
      infoPanel.addClass('show');
      infoPanel.find('p').addClass('show');
    }
  });
});

/**
 * Dashboard QR code
 */
var qrCode = document.getElementById("dashboard-qr-code");
var qrValue =
  window.location.origin + "/login-ml?id=" + $("#dashboard-qr-value").html();

if (qrCode !== null && typeof qrValue !== "undefined") {
  QRCode.toCanvas(qrCode, qrValue, function (error) {
    if (error) console.error(error);
  });
}

/**
 * Event Badge QR code
 * 
 */

var badgeQrCode = document.getElementById("event-badge-qr-code");
var badgeQrLink = document.getElementById("event-badge-qr-code-value");

if (badgeQrCode !== null && typeof badgeQrLink !== "undefined") {
  var badgeQrValue = document.getElementById("event-badge-qr-code-value").href;
  QRCode.toCanvas(badgeQrCode, badgeQrValue, function (error) {
    if (error) console.error(error);
  });
}

/* Help button */
$(document).on("click", "#help-btn", function (e) {
  var popup = $("#help-popup");
  var button = $("#help-btn");
  if (popup.hasClass("show") && button.hasClass("show")) {
    popup.removeClass("show");
    button.removeClass("show");
    popup.fadeOut();
  } else {
    popup.addClass("show");
    button.addClass("show");
    popup.fadeIn();
  }
});

/* Profile form info toggle */
var infoToggled = false;
$(document).on("click", "#address-more-info", function (e) {
  if (!infoToggled) {
    $('#address-more-info-icon').css({ 'transform': 'rotate(180deg)' });
    $('#adress-extra-info').fadeIn();
    infoToggled = true;
  } else {
    $('#address-more-info-icon').css({ 'transform': 'none' });
    $('#adress-extra-info').fadeOut();
    infoToggled = false;
  }
});

/* Profile form address edit */
var isAddressHidden = false;
function updateAddressVisibility() {
  if (isAddressHidden) {
    $('#edit-address-btn').hide();
    $('#full-address').hide();
    $('div[id^="edit-address"]').show();
  } else {
    $('#edit-address-btn').show();
    $('#full-address').show();
    $('div[id^="edit-address"]').hide();
  }
}

$(function () {
  // Initial update when the page loads
  updateAddressVisibility();

  $(document).on("click", "#edit-address-btn", function (e) {
    e.preventDefault();

    $(this).hide();
    $('#full-address').hide();
    $('div[id^="edit-address"]').fadeIn(200);

    isAddressHidden = true;
  });

  // Reapply the logic after each AJAX form submission
  $(document).ajaxComplete(function (event, xhr, settings) {
    updateAddressVisibility();
  });
});

// Help popup
var helpPopup = $("#help-popup");
$(document).on("click", ".info-link", function (e) {
  if (helpPopup.hasClass("show")) {
    hideHelpPopup();
  } else {
    showHelpPopup();
  }
});

$(document).on("click", "#help-popup .close-button", function (e) {
  if (helpPopup.hasClass("show")) {
    hideHelpPopup();
  } else {
    showHelpPopup();
  }
});

function hideHelpPopup() {
  helpPopup.removeClass("show");
  helpPopup.fadeOut(200);
}

function showHelpPopup() {
  helpPopup.addClass("show");
  helpPopup.fadeIn(200);
}

// Remove user from team
$('.remove-member').on('click', function (event) {
  event.preventDefault();

  var teamId = $(this).data('teamId');
  var userId = $(this).data('userId');
  var $memberElement = $(this).closest('.views-row'); // Define variable here

  $.ajax({
    url: '/team/' + teamId + '/remove-member/' + userId,
    method: 'GET',
    success: function (data) {
      console.log(data.success);
      $memberElement.fadeOut(400, function () {
        $memberElement.remove();
      });
    }
  });
});


$(function () {
  const tags = $('.uv-faq-list .bef-exposed-form form');
  let isDown = false;
  let startX;
  let scrollLeft;

  tags.on('mousedown', function (e) {
    isDown = true;
    startX = e.pageX - tags.offset().left;
    scrollLeft = tags.scrollLeft();
  });

  tags.on('mouseleave mouseup', function () {
    isDown = false;
  });


  tags.on('mousemove', function (e) {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - tags.offset().left;
    const walk = (x - startX) * 1.5; // You can adjust the speed of the scroll here
    tags.scrollLeft(scrollLeft - walk);
  });
});


// Dashboard News Box collapse and News Box  open/closed state save
const isExpanded = localStorage.getItem('isExpanded');
const newsBox = document.querySelector('.paragraph--type--dashboard-news-box');

if (newsBox !== null) {

  if (isExpanded === 'true') {
    newsBox.classList.add('expanded');
    newsBox.classList.remove('closed');

  } else {
    newsBox.classList.remove('expanded');
    newsBox.classList.add('closed');
  }
  // must be added like this or flickering SVG on pageload
  const style = document.createElement('style');
  style.textContent = `
  .paragraph--type--dashboard-news-box > .field--name-field-title:after {
    transition: transform 200ms ease-in-out; 
  }
`;

  newsBox.addEventListener('click', () => {
    newsBox.classList.toggle('expanded');
    newsBox.classList.toggle('closed');

    newsBox.classList.add('transition-enabled');
    const currentState = newsBox.classList.contains('expanded');
    localStorage.setItem('isExpanded', currentState);
  });

}

/*
 * Visually disable submit button until all required fields are filled.
 */
$(function () {
  // The delegated event handler will catch input and change events on any form whose ID starts with the prefix.
  function checkFields() {
    // Loop over each matching form in case there are more than one.
    $("[id^='webform-submission-sign-up-add-form']").each(function () {
      var $form = $(this);
      var $email = $form.find("[name='email']");
      var $firstName = $form.find("[name='first_name']");
      var $lastName = $form.find("[name='last_name']");
      var $consent = $form.find("[name='privacy']");
      var $submit = $form.find("[type='submit']");

      if (!$email.length || !$firstName.length || !$lastName.length || !$consent.length || !$submit.length) {
        console.warn("One or more fields missing in form " + $form.attr("id") + ". Skipping validation.");
        return;
      }

      // Use $.trim to avoid errors if values are undefined.
      var isEmailFilled = $.trim($email.val()) !== "";
      var isFirstNameFilled = $.trim($firstName.val()) !== "";
      var isLastNameFilled = $.trim($lastName.val()) !== "";
      var isConsentChecked = $consent.is(":checked");

      if (isEmailFilled && isFirstNameFilled && isLastNameFilled && isConsentChecked) {
        $submit.removeClass("disabled");
      } else {
        $submit.addClass("disabled");
      }
    });
  }

  // Delegate events from the document so dynamic (AJAX) forms are handled.
  $(document).on("input", "[id^='webform-submission-sign-up-add-form'] [name='email'], " +
    "[id^='webform-submission-sign-up-add-form'] [name='first_name'], " +
    "[id^='webform-submission-sign-up-add-form'] [name='last_name']", checkFields);
  $(document).on("change", "[id^='webform-submission-sign-up-add-form'] [name='privacy']", checkFields);

  // Run an initial check in case the form is already loaded.
  checkFields();
});

